import { useEffect } from "react";

/**
 * Lightweight SEO helper — sets <title> and <meta name="description"> for the
 * current page. Also sets a canonical <link> matching window.location.
 */
export default function useSEO({ title, description, canonicalPath } = {}) {
  useEffect(() => {
    if (title) document.title = title;

    if (description) {
      let el = document.querySelector('meta[name="description"]');
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute("name", "description");
        document.head.appendChild(el);
      }
      el.setAttribute("content", description);
    }

    if (canonicalPath) {
      let link = document.querySelector('link[rel="canonical"]');
      if (!link) {
        link = document.createElement("link");
        link.setAttribute("rel", "canonical");
        document.head.appendChild(link);
      }
      const origin = window.location.origin;
      link.setAttribute("href", `${origin}${canonicalPath}`);
    }
  }, [title, description, canonicalPath]);
}
